import { render } from "./MsOffice.vue?vue&type=template&id=2b0c9f60&scoped=true"
import script from "./MsOffice.vue?vue&type=script&lang=js"
export * from "./MsOffice.vue?vue&type=script&lang=js"

import "./MsOffice.vue?vue&type=style&index=0&id=2b0c9f60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b0c9f60"]])

export default __exports__